var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalResizeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 17.3334H29.3333V2.66669C29.3333 1.196 28.1374 0 26.6666 0H5.33331C3.86263 0 2.66663 1.19594 2.66663 2.66669V17.3334H0.666625C0.298188 17.3334 0 17.6315 0 18V18.6667C0 20.1374 1.19594 21.3334 2.66669 21.3334H29.3334C30.8041 21.3334 32 20.1374 32 18.6667V18C32 17.6315 31.7018 17.3334 31.3333 17.3334ZM4 2.66669C4 1.93169 4.59831 1.33338 5.33331 1.33338H26.6666C27.4016 1.33338 27.9999 1.93169 27.9999 2.66669V17.3334H19.3333H12.6667H4V2.66669ZM29.3333 20H2.66669C1.93169 20 1.33337 19.4017 1.33337 18.6667H3.33337H12.3906L12.862 19.1381C12.987 19.2631 13.1562 19.3334 13.3334 19.3334H18.6667C18.8438 19.3334 19.0131 19.2631 19.1381 19.1381L19.6094 18.6667H28.6667H30.6667C30.6667 19.4017 30.0684 20 29.3333 20Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalResizeIcon);
export default __webpack_public_path__ + "static/media/modal-resize-icon.0700291f.svg";
export { ForwardRef as ReactComponent };